module.exports = ".card {\n  padding: 20px 0px 20px 0px; }\n\n.card-img-top {\n  width: 224px;\n  height: 197px; }\n\n.product-actionsButton {\n  width: 160px;\n  margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/container/container.component.scss
// module id = ./src/app/container/container.component.scss
// module chunks = main